import React from "react";
import styled from "styled-components";
import PopupLink from "../../../../../components/PopupLink";

const MainHeader = styled.h1`
  font-size: 1.5em;
`;
// const SubHeader = styled.h2`
//   font-size: 1em;
// `
const Content = styled.p`
  font-size: 0.8em;
`;

const PopupContent = () => (
  <div>
    <MainHeader> Baggage Fees </MainHeader>
    <Content>
      Many airlines charge fees for checked and carry-on baggage, which are not
      included in your trip cost. These fees are the traveler's responsibility
      and will be paid directly to the airline.
    </Content>

    <Content>
      Baggage fee policies vary by airline, and are subject to change by the
      airline at any time. Amounts are based upon destination, bag size and
      weight and additional fees may apply if your bag exceeds airline size and
      weight limits.
    </Content>
    <Content>
      Information about airline fees for carry-on baggage and the first and
      second checked bags will be provided in the booking process; total baggage
      cost and restriction information can be obtained on your confirmed
      airline’s website.
    </Content>
  </div>
);

function BaggageFeesLink() {
  return <PopupLink linkText="Baggage fees" popupContent={<PopupContent />} />;
}

export default BaggageFeesLink;



// WEBPACK FOOTER //
// ./src/scenes/ReviewOrder/ChargesSummary/BaggageFeesDisclaimer/BaggageFeesLink/index.js